import isPlainObject from 'is-plain-object';
import { isFunction } from 'lodash';

let _resolve;

export const trackCbReceived = new Promise((resolve) => {
  _resolve = resolve;
});

const getDataFromState = (data, state) =>
  isFunction(data)
    ? data(state)
    : isPlainObject(data)
    ? Object.keys(data).reduce((acc, key) => {
        acc[key] = isFunction(data[key]) ? data[key](state) : data[key];
        return acc;
      }, {})
    : data;

export const onTrack = (cb, recState) => {
  _resolve(({ eventData = {}, sectionData }) => {
    const state = isFunction(recState) ? recState() : recState;
    const _eventData = state ? getDataFromState(eventData, state) : eventData;
    const _sectionData = sectionData && state ? getDataFromState(sectionData, state) : sectionData;
    const data = _sectionData ? { ..._eventData, ..._sectionData } : _eventData;

    return cb(data);
  });
};
